import { Component, Input } from '@angular/core';
import { EXPANSION_PANEL_ANIMATION_TIMING } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { timer } from 'rxjs';

@Component({
    selector: 'app-expansion-panel-v2',
    imports: [CommonModule],
    templateUrl: './expansion-panel-v2.component.html',
    styleUrl: './expansion-panel-v2.component.scss',
    animations: [
        trigger('bodyExpansion', [
            state('collapsed', style({
                height: '0px',
                opacity: 0,
                transform: 'translateY(-10px)',
                visibility: 'hidden',
            })),
            state('expanded', style({
                height: '*',
                opacity: 1,
                transform: 'translateY(0)',
                visibility: 'visible',
            })),
            transition('expanded <=> collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
        ]),
    ]
})
export class ExpansionPanelV2Component {
  isExpanded = false;
  // helps eliminate a bug where the scrollbar shows for a moment after an expansion occurs
  // (BEWARE: hacky, but this is the best solution I could find, trying to produce a cleaner fix seems to only lead to more bugs)
  isExpandedBugfix = false;
  @Input() set expanded(val: boolean) {
    if (val === true) {
      this.isExpandedBugfix = val;
      this.isExpanded = val;
    } else {
      this.isExpanded = val;
      timer(225).subscribe(() => {
        // wait till animation end (animation lasts 225ms)
        this.isExpandedBugfix = val;
      });
    }
  }
}
